export type EventDateTimeLike = {
  event_date?: string | null;
  start_time?: string | null;
  end_time?: string | null;
  ends_next_day?: boolean | null;
  start_date?: string | null;
  end_date?: string | null;
};

export const formatEventTypeLabel = (type?: string | null) => {
  const normalized = (type ?? '').trim();
  if (!normalized) return 'Event';

  return normalized
    .replace(/[_-]+/g, ' ')
    .toLowerCase()
    .replace(/\b\w/g, (letter) => letter.toUpperCase());
};

export const formatEventDateLong = (event: EventDateTimeLike) => {
  try {
    if (event.event_date) {
      const date = new Date(event.event_date);
      if (!Number.isNaN(date.getTime())) {
        return date.toLocaleDateString('en-GB', {
          weekday: 'long',
          day: 'numeric',
          month: 'long',
          year: 'numeric',
        });
      }
    }

    if (event.start_date) {
      const date = new Date(event.start_date);
      if (!Number.isNaN(date.getTime())) {
        return date.toLocaleDateString('en-GB', {
          weekday: 'long',
          day: 'numeric',
          month: 'long',
          year: 'numeric',
        });
      }
    }

    return 'Date TBA';
  } catch {
    return 'Date TBA';
  }
};

const formatExplicitTime = (timeStr: string) => {
  const [hoursRaw, minutesRaw] = timeStr.split(':');
  const hours = Number.parseInt(hoursRaw ?? '', 10);
  const minutes = minutesRaw ?? '00';
  if (!Number.isFinite(hours)) return undefined;

  const hour24 = hours;
  const hour12 =
    hour24 === 0 ? 12 : hour24 > 12 ? hour24 - 12 : hour24;
  const ampm = hour24 >= 12 ? 'PM' : 'AM';
  return `${hour12}:${minutes}${ampm}`;
};

export const formatEventTimeRange = (event: EventDateTimeLike) => {
  try {
    if (event.start_time) {
      const startTime = formatExplicitTime(event.start_time);
      if (startTime) {
        if (event.end_time) {
          const endTime = formatExplicitTime(event.end_time);
          if (endTime) {
            const nextDay = event.ends_next_day ? ' (+1)' : '';
            return `${startTime} - ${endTime}${nextDay}`;
          }
        }
        return startTime;
      }
    }

    if (event.start_date) {
      const startDate = new Date(event.start_date);
      if (!Number.isNaN(startDate.getTime())) {
        const startTime = startDate.toLocaleTimeString('en-GB', {
          hour: '2-digit',
          minute: '2-digit',
        });

        if (event.end_date) {
          const endDate = new Date(event.end_date);
          if (!Number.isNaN(endDate.getTime())) {
            const endTime = endDate.toLocaleTimeString('en-GB', {
              hour: '2-digit',
              minute: '2-digit',
            });
            return `${startTime} - ${endTime}`;
          }
        }

        return startTime;
      }
    }

    return 'Time TBA';
  } catch {
    return 'Time TBA';
  }
};

